export default [
	[
		{
			img: require("../assets/imgs/home/home-service-jilin.png"),
			title: '吉林系列',
			desc: '吉林系列卫星由多个卫星组成，如吉林一号A/B卫星、吉林三号卫星等，数据主要应用于土地利用监测、环境监测、资源调查、农业预警、城市规划以及自然灾害监测等领域。',
			toUrl: ''
		}, {
			img: require("../assets/imgs/home/home-service-beijing.png"),
			title: '北京系列',
			desc: '北京系列三代卫星是甚高分辨率、高性能光学遥感卫星，具有高精度、高敏捷、高效能的遥感大数据获取能力，可提供及时自主的甚高分辨率遥感大数据及空间信息综合应用服务',
			toUrl: ''
		}, {
			img: require("../assets/imgs/home/home-service-zhuhai.png"),
			title: '珠海系列',
			desc: '“珠海一号”卫星星座，是我国首个由民营企业发射并运营的商业遥感维纳卫星星座。整个星座由分布在不同轨道的34颗卫星组成。',
			toUrl: ''
		}, {
			img: require("../assets/imgs/home/home-service-ht.png"),
			title: '宏图系列',
			desc: '国内首个干涉SAR商业卫星星座，该星座在国际上首次采用分布式星座构型，“1主+3辅”4星共面运行，具备高精度地形测绘、高精度形变检测、高分辨率宽幅成像以及三维立体成像等能力',
			toUrl: ''
		}, {
			img: require("../assets/imgs/home/home-service-tianyi.png"),
			title: '天仪系列',
			desc: '规划的轻小型SAR遥感卫星星座，能够实现高分辨率、宽覆盖、持续监测、快速遥感信息处理能力，为商业用户提供多样化、高质量、极致性价比的SAR卫星数据服务。',
			toUrl: ''
		}, {
			img: require("../assets/imgs/home/home-service-qilu.png"),
			title: '齐鲁系列',
			desc: '齐鲁卫星星座在国内首次尝试采用“天基互联+遥感小卫星”的创新应用模式，是我国第一个基于激光通信互联的遥感小卫星星座。',
			toUrl: ''
		}
	], [
		{
			img: require("../assets/imgs/home/home-service-nongye.png"),
			title: '农业数据',
			desc: '致力于提供高质量农业遥感数据，助力农业科学研究、决策和可持续发展。',
			toUrl: ''
		},{
			img: require("../assets/imgs/home/home-service-gaocheng.png"),
			title: '高程数据',
			desc: '基于先进软法技术，提供高精度、可靠数据，使您深入了解地表高程特征，探索地形奥秘。',
			toUrl: ''
		},{
			img: require("../assets/imgs/home/home-service-xingbian.png"),
			title: '形变数据',
			desc: '多领域、长时序、高精度InSAR形变数据产品，以期带您及时发现地球脉动，深入解读地表的变化！',
			toUrl: ''
		},{
			img: require("../assets/imgs/home/home-service-turang.png"),
			title: '土壤墒情',
			desc: '提供多维度、广覆盖的土地湿度密码信息，助您深入了解土壤关键指标，助力农业生产更上一层。',
			toUrl: ''
		},{
			img: require("../assets/imgs/home/home-service-shuiti.png"),
			title: '水体提取',
			desc: '提供多维度、广覆盖的土地湿度密码信息，助您深入了解土壤关键指标，助力农业生产更上一层。',
			toUrl: ''
		},{
			img: require("../assets/imgs/home/home-service-qixiang.png"),
			title: '气象数据',
			desc: '先进遥感技术为天空变化、气候趋势和环境状况提供丰富气象信息，揭开风云变化秘密。',
			toUrl: ''
		}
	], [
		{
			img: require("../assets/imgs/home/home-service-siyouhua.png"),
			title: '私有化服务',
			desc: '私有化服务是一种将传统的软件、应用程序或基础设施部署在私有环境中的解决方案。具有数据安全、定制化、合规性和高性能的特点。',
			toUrl: ''
		},{
			img: require("../assets/imgs/home/home-service-ruanjian.png"),
			title: '软件工具',
			desc: '通过自动化和简化重复性任务，提高工作效率。处理复杂的任务和数据，将其转化为用户友好的界面和操作。',
			toUrl: ''
		},{
			img: require("../assets/imgs/home/home-service-SAAS.png"),
			title: 'SAAS服务',
			desc: '以云计算为基础，通过Internet提供软件应用程序给用户，用户无需购买、安装和维护软件，而是通过订阅的方式使用该软件。',
			toUrl: ''
		},
	], [
		{
			img: require("../assets/imgs/home/home-service-siyouhua.png"),
			title: '私有化服务',
			desc: '私有化服务是一种将传统的软件、应用程序或基础设施部署在私有环境中的解决方案。具有数据安全、定制化、合规性和高性能的特点。',
			toUrl: ''
		},{
			img: require("../assets/imgs/home/home-service-ruanjian.png"),
			title: '软件工具',
			desc: '通过自动化和简化重复性任务，提高工作效率。处理复杂的任务和数据，将其转化为用户友好的界面和操作。',
			toUrl: ''
		},{
			img: require("../assets/imgs/home/home-service-SAAS.png"),
			title: 'SAAS服务',
			desc: '以云计算为基础，通过Internet提供软件应用程序给用户，用户无需购买、安装和维护软件，而是通过订阅的方式使用该软件。',
			toUrl: ''
		},
	]
]